<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="项目编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'projectId', validatorRules.projectId]" placeholder="请输入项目编号"></a-input>
        </a-form-item>
        <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'projectName', validatorRules.projectName]" placeholder="请输入项目名称"></a-input>
        </a-form-item>
        <a-form-item label="任务类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'taskType', validatorRules.taskType]" placeholder="请输入任务类型"></a-input>
        </a-form-item>
        <a-form-item label="任务编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'taskId', validatorRules.taskId]" placeholder="请输入任务编号" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="父任务编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'taskPid', validatorRules.taskPid]" placeholder="请输入父任务编号" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="任务名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'taskName', validatorRules.taskName]" placeholder="请输入任务名称"></a-input>
        </a-form-item>
        <a-form-item label="任务状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'taskStatus', validatorRules.taskStatus]" placeholder="请输入任务状态"></a-input>
        </a-form-item>
        <a-form-item label="处理人" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'handler', validatorRules.handler]" placeholder="请输入处理人"></a-input>
        </a-form-item>
        <a-form-item label="开发人员" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'developers', validatorRules.developers]" placeholder="请输入开发人员"></a-input>
        </a-form-item>
        <a-form-item label="完成度" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'doneRatio', validatorRules.doneRatio]" placeholder="请输入完成度"></a-input>
        </a-form-item>
        <a-form-item label="实际工时" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'actualWorkHours', validatorRules.actualWorkHours]" placeholder="请输入实际工时" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="迭代" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'iteration', validatorRules.iteration]" placeholder="请输入迭代"></a-input>
        </a-form-item>
        <a-form-item label="预计开始日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择预计开始日期" v-decorator="[ 'beginTime', validatorRules.beginTime]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="预计结束日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择预计结束日期" v-decorator="[ 'endTime', validatorRules.endTime]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="创建时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择创建时间" v-decorator="[ 'createdTime', validatorRules.createdTime]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="更新时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择更新时间" v-decorator="[ 'updatedTime', validatorRules.updatedTime]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="结束时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择结束时间" v-decorator="[ 'closedTime', validatorRules.closedTime]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'  

  export default {
    name: "BusWeeklySummaryModal",
    components: { 
      JDate,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          projectId: {rules: [
          ]},
          projectName: {rules: [
            {required: true, message: '请输入项目名称!'},
          ]},
          taskType: {rules: [
            {required: true, message: '请输入任务类型!'},
          ]},
          taskId: {rules: [
            {required: true, message: '请输入任务编号!'},
          ]},
          taskPid: {rules: [
          ]},
          taskName: {rules: [
          ]},
          taskStatus: {rules: [
            {required: true, message: '请输入任务状态!'},
          ]},
          handler: {rules: [
            {required: true, message: '请输入处理人!'},
          ]},
          developers: {rules: [
          ]},
          doneRatio: {rules: [
          ]},
          actualWorkHours: {rules: [
          ]},
          iteration: {rules: [
          ]},
          beginTime: {rules: [
          ]},
          endTime: {rules: [
          ]},
          createdTime: {rules: [
          ]},
          updatedTime: {rules: [
          ]},
          closedTime: {rules: [
          ]},
        },
        url: {
          add: "/org.jeecg/busWeeklySummary/add",
          edit: "/org.jeecg/busWeeklySummary/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'projectId','projectName','taskType','taskId','taskPid','taskName','taskStatus','handler','developers','doneRatio','actualWorkHours','iteration','beginTime','endTime','createdTime','updatedTime','closedTime'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'projectId','projectName','taskType','taskId','taskPid','taskName','taskStatus','handler','developers','doneRatio','actualWorkHours','iteration','beginTime','endTime','createdTime','updatedTime','closedTime'))
      },

      
    }
  }
</script>